<template>
  <div class="vueTour">
      <i class="material-icons helpIcon" @click="showHelp">
      help_outline
      </i>
  </div>
</template>

<script>
export default {
  name: "VueTour",
  methods: {
      showHelp () {
        this.$tours['myTour'].start()
      }
    }
  };
</script>

<style lang="scss">
  @import '@/style/_variables.scss';
 .helpIcon{
   color: $medium_light_grey;
   margin-top:11px;
   margin-right: 10px;
 }
 .helpIcon:hover {
   color: #868686;
   cursor: pointer;
 }
</style>